module.exports = __webpack_public_path__ + "static/img/step-1-thumbnail.b52a84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/step-1-thumbnail.png
// module id = 90
// module chunks = 1